import first from "lodash/first";
import nth from "lodash/nth";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { breadcrumbNewsletterArticleArticle$key } from "scmp-app/queries/__generated__/breadcrumbNewsletterArticleArticle.graphql";

import { ArticleTypeName, Container, StyledBaseEntityLink } from "./styles";

type Props = {
  className?: string;
  reference: breadcrumbNewsletterArticleArticle$key;
};

export const NewsletterArticleBreadcrumb: FunctionComponent<Props> = ({ className, reference }) => {
  const article = useFragment(
    graphql`
      fragment breadcrumbNewsletterArticleArticle on Article {
        types {
          value {
            name
          }
        }
      }
    `,
    reference,
  );

  const newsletterLink = {
    entityId: "n/a",
    name: "Newsletters",
    routeType: "Static",
    urlAlias: "/newsletters",
  };

  const articleTypeNames = first(article.types?.filter(notEmpty))
    ?.value?.filter(notEmpty)
    .map(type => type?.name);

  return (
    <Container className={className}>
      <StyledBaseEntityLink linkEntity={newsletterLink}>{newsletterLink.name}</StyledBaseEntityLink>
      <ArticleTypeName>{nth(articleTypeNames, 1)}</ArticleTypeName>
    </Container>
  );
};

NewsletterArticleBreadcrumb.displayName = "NewsletterArticleBreadcrumb";
